var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    ref: "dom",
    class: _vm.classObj,
    on: {
      "click": _vm.handleClick
    }
  }, [_c('h5', {
    domProps: {
      "textContent": _vm._s(_vm.text)
    }
  })]) : _vm._e()])
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5ff29300", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ff29300"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Toast/n3Toast.vue
// module id = 631
// module chunks = 0 1